<template>
  <div class="carousel-deck-widget-container">
    <carousel-deck-row
      v-for="deck in decks"
      :key="deck.id"
      :deck="deck"
      :fallback-icon-attachment-id="fallbackIconAttachmentId"
      :fallback-image-type="fallbackImageType"
    />
  </div>
</template>

<script>
import CarouselDeckRow from '@components/dashboard-widgets/CarouselDeckRow.vue';

export default {
  components: {
    CarouselDeckRow,
  },
  props: {
    config: {
      type: Object,
    },
  },
  computed: {
    decks() {
      let deckIds = [];
      if (this.config?.decks) {
        deckIds = [...this.config?.decks]
          .sort((a, b) => a.order - b.order)
          .map((deck) => deck.id);
        }
      return deckIds.map((deckId) => this.$store.getters['decks/get'][deckId]);
    },
    fallbackIconAttachmentId() {
      if (this.config) {
        return this.config?.config?.fallbackIconAttachmentId;
      }
      return '';
    },
    fallbackImageType() {
      if (this.config) {
        return this.config?.config?.imageType;
      }
      return '';
    },
  },
  watch: {
    decks() {
      this.fetchAttachments();
    },
    fallbackIconAttachmentId() {
      this.fetchAttachments();
    },
  },
  created() {
    this.fetchAttachments();
  },
  methods: {
    fetchAttachments() {
      this.$store.dispatch('attachments/fetch', { ids: this.getAllImageIds() });
    },
    getAllImageIds() {
      const imageIds = [];
      if (this.fallbackIconAttachmentId) {
        imageIds.push(this.fallbackIconAttachmentId);
      }
      this.decks.forEach((deck) => {
        deck.cards.forEach((card) => {
          if (card.featuredImageId) {
            imageIds.push(card.featuredImageId);
          }
        });
      });
      return imageIds;
    },
  },
};
</script>
